<template>
  <div class="fixed-plugin configurator-settings">
    <!-- <a
      class="px-3 py-2 fixed-plugin-button text-dark position-fixed"
      @click="toggle"
    >
      <i class="material-icons py-2">settings</i>
    </a> -->
    <div class="shadow-lg card">
      <div class="pt-3 pb-0 bg-transparent card-header">
        <div class="mt-4 float-end" @click="toggle">
          <button class="p-0 btn btn-link text-dark fixed-plugin-close-button">
            <i class="material-icons">clear</i>
          </button>
        </div>
        <!-- End Toggle Button -->
      </div>
        <slot />
    </div>
  </div>
</template>

<script>

export default {
  name: "configurator",
  props: ["toggle"],
  
};
</script>

<style scoped>
.fixed-plugin {
  z-index: 1000;
}
</style>